import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@material-ui/core";
import {
    checkMaterialsDeleteStatus,
    checkUploadedMaterialsStatus,
    fetchPrintValidationReport,
    getMaterialDetailsById,
    getMaterialsProcessingStatus,
    getPreflightReportStatus,
} from "store/features/materialSpecs/specs";
import { useDispatch, useSelector } from "react-redux";
import WarningIcon from "@material-ui/icons/Warning";
import { useProcessingStatus } from "hooks";
import { isEmpty, serverAddress } from "utils";
import Iframe from "react-iframe";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";

export const PrintValidation = () => {
    const dispatch = useDispatch();
    const { palette } = useTheme();
    const { hasError } = useSelector(getMaterialsProcessingStatus);
    const { t } = useTranslation();
    const { selectedMaterialSpecId, selectedMaterialId } = useMaterialSpecs();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    useProcessingStatus(false, hasError);
    const isAnyMaterialUploading = useSelector(checkUploadedMaterialsStatus);
    const isAnyMaterialDeleting = useSelector(checkMaterialsDeleteStatus);
    const isPreflightLoading = useSelector(getPreflightReportStatus);

    useEffect(() => {
        if (
            materialDetails?.inputFileName &&
            selectedMaterialId &&
            !materialDetails?.printPreflightReport &&
            !isAnyMaterialUploading &&
            !isAnyMaterialDeleting &&
            !isPreflightLoading
        ) {
            dispatch(fetchPrintValidationReport.request(selectedMaterialId));
        }

        // eslint-disable-next-line
    }, [selectedMaterialId, isPreflightLoading]);

    if (!materialDetails || !materialDetails.printPreflightReport) {
        return null;
    }

    if (isEmpty(materialDetails.printPreflightReport)) {
        return (
            <Typography component="div" variant="subtitle1">
                <Box
                    pb={2}
                    display="flex"
                    textAlign="center"
                    justifyContent="center"
                    alignItems="center"
                    color={palette.warning.main}
                    fontWeight="fontWeightBold">
                    <Box display="flex" pr={2}>
                        <WarningIcon color="inherit" />
                    </Box>
                    {t("campaign.errors.preflightMissingMetadata")}
                </Box>
            </Typography>
        );
    }

    return (
        <Box flex={1} height="35vh" position="relative">
            <Iframe
                frameBorder={0}
                url={`${serverAddress}${materialDetails.printPreflightReport.xmllogUrl}`}
                height="100%"
                width="100%"
                position="absolute"
            />
        </Box>
    );
};
